 const ROUTES = [
    {path:"/laptops", title: "Laptops"},
    {path:"/techsupport", title: "Tech Support"},
    {path:"/about", title: "About"},
]
export default ROUTES